import { Injectable } from "@angular/core";
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from "@angular/router";
import {Observable, of} from "rxjs";
import { map } from "rxjs/operators";
import { CompanyService } from "./company.service";

@Injectable({
  providedIn: 'root'
})
export class CompanyGuard implements CanActivate {
  constructor(private companyService: CompanyService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    const hasCompany = this.companyService.hasCompany();

    if (!hasCompany) {
      // Return the Observable from loadCompanies
      return this.companyService.loadCompanies().pipe(
        map(companies => {
          // If there are no companies, redirect to the "create new company" page
          if (!companies || companies.length === 0) {
            return this.router.createUrlTree(['/company/new']);
          }
          // If there are companies, allow the route activation
          return true;
        })
      );
    }

    // If the user has a company, allow the route activation
    return of(hasCompany);
  }
}
